import {Fragment} from 'react';

import {gettext} from 'topmeteo/utils/i18n';

/* Translators: location forecast - message when no favorites are set, but only favorites are shown */
const Message = gettext('You have not selected any favourite products.');

const NoFavouritesSelectedMessage = () => (
    <Fragment>
        <div className="notifications-header" />
        <div className="notifications-inner inverse alert user-profile info alert-info" role="alert">
            <p className="no-favourites-selected">{Message}</p>
        </div>
    </Fragment>
);

export default NoFavouritesSelectedMessage;
